import React from "react";
import { Box, Tabs, Tab } from "@mui/material";


const CategorySection = ({
  selectedCategory,
  categoryImage,
  menus,
  tabIndex,
  onTabChange,
  searchQuery,
  isMobile,
}) => {
  return (
    <>
      {/* صورة المجاميع */}
      {selectedCategory && !searchQuery && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 1, sm: 1.5, md: 2 },
            mb: { xs: 1.25, sm: 1.75, md: 2 },
            px: { xs: 1.25, sm: 2 },
          }}
        >
          <Box
            sx={{
              width: { xs: 85, sm: 120, md: 160, lg: 200 },
              height: { xs: 85, sm: 120, md: 160, lg: 200 },
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: "0 4px 20px rgba(255, 61, 61, 0.12)",
              border: { xs: "3px solid #fffbe6", md: "4px solid #fffbe6" },
              bgcolor: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.3s",
              "&:hover": {
                transform: "scale(1.05)",
              }
            }}
          >
            <img
              src={categoryImage}
              alt={selectedCategory.category?.name || "تصنيف"}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>
        </Box>
      )}

      {/* Tabs للفئات */}
      {!searchQuery && (
        <Box sx={{ 
          display: "flex", 
          justifyContent: "center", 
          mb: { xs: 1.5, sm: 2.5, md: 3.5 },
          px: { xs: 0.75, sm: 1.5, md: 2 },
        }}>
          <Tabs
            value={tabIndex}
            onChange={(_, v) => onTabChange(v)}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              bgcolor: "#fff",
              borderRadius: { xs: 2, md: 2.5 },
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
              px: { xs: 0.75, sm: 1.5 },
              minHeight: { xs: 40, sm: 44, md: 48 },
              maxWidth: "100%",
              "& .MuiTab-root": {
                fontWeight: 700,
                color: "#222",
                fontSize: { xs: 12.5, sm: 14.5, md: 16 },
                mx: { xs: 0.25, sm: 0.75 },
                px: { xs: 1.25, sm: 1.75, md: 2.5 },
                py: { xs: 0.75, sm: 1 },
                borderRadius: 1.5,
                minHeight: { xs: 40, sm: 44, md: 48 },
                minWidth: { xs: 70, sm: 90 },
                transition: "all 0.2s",
                "&.Mui-selected": {
                  color: "#ff3d3d",
                  bgcolor: "#fffbe6",
                  transform: "scale(1.02)",
                },
                "&:hover": {
                  bgcolor: "#fffef5",
                }
              },
              "& .MuiTabs-scrollButtons": {
                width: { xs: 28, sm: 36 },
                "&.Mui-disabled": {
                  opacity: 0.3,
                }
              },
            }}
            TabIndicatorProps={{
              style: { 
                background: "#ff3d3d", 
                height: isMobile ? 2.5 : 3, 
                borderRadius: 2 
              },
            }}
          >
            {menus.map((item) => (
              <Tab key={item.category.id} label={item.category.name} />
            ))}
          </Tabs>
        </Box>
      )}
    </>
  );
};

export default CategorySection;
